import React from 'react';
import styles from './styles.module.css';

export const orderItemStatusBadge = (status) => {
  const statuses = {
    Added: <p className={`${styles.matchStatus} ${styles.statusAdded}`}>Added</p>,
    Removed: <p className={`${styles.matchStatus} ${styles.statusRemoved}`}>Removed</p>,
    'Contact pharmacy': (
      <p className={`${styles.matchStatus} ${styles.statusContactPharmacy}`}>Contact pharmacy</p>
    ),
    Default: <p className={`${styles.matchStatus} ${styles.statusDefault}`}>{status}</p>,
  };
  return statuses[status] || statuses['Default'];
};

const OrderItem = ({ data: { match_3_status, status, name } }) => {
  const itemStatus = match_3_status || status;
  return (
    <li className={styles.orderItem}>
      <div className={itemStatus === 'Removed' ? styles.itemRemoved : ''}>{name}</div>
      {orderItemStatusBadge(itemStatus)}
    </li>
  );
};

export default OrderItem;
